import {
  MappedClass,
  MappedPropertyArrayOptional,
  MappedPropertyClassOptional,
  MappedPropertyOptional,
} from '@h5s/util-object';
import { ZPrinterFiscalMessage } from './z-printer-fiscal-message';
import { ZPrinterFiscalPrinterStatus } from './z-printer-fiscal-printer-status';

@MappedClass()
export class ZPrinterFiscalProtocol {
  @MappedPropertyOptional()
  are_responses_matching_packet_id?: boolean | null;

  @MappedPropertyOptional()
  duration?: number | null;

  @MappedPropertyOptional()
  end?: string | null;

  @MappedPropertyOptional()
  is_success?: boolean | null;

  @MappedPropertyOptional()
  read_error?: boolean | null;

  @MappedPropertyClassOptional(() => ZPrinterFiscalMessage)
  request?: ZPrinterFiscalMessage | null;

  @MappedPropertyArrayOptional(() => ZPrinterFiscalMessage)
  response?: ZPrinterFiscalMessage[] | null;

  @MappedPropertyOptional()
  response_body?: string[] | null;

  @MappedPropertyOptional()
  response_body_string?: string | null;

  @MappedPropertyOptional()
  start?: string | null;

  @MappedPropertyOptional()
  status?: ZPrinterFiscalPrinterStatus | null;

  @MappedPropertyOptional()
  write_error?: boolean | null;
}
